export default __webpack_public_path__ + "static/media/SortIconRedUp.e2971a14.svg";